
//NOT EDITABLE!!!
import Hero from "../../components/Hero"
import Footer from "../../components/Footer"
import Topography from "../../components/Topography"

// EDITABLE
import background from "../../assets/img/background.png" //Background
import backgroundMobile from "../../assets/img/background.png" //BackgroundMobile
import logo from '../../assets/img/logo.png'; //Logo

function pageLayout( props ) {
    //EDITABLE
    const deskripsi = "Selamat datang kembali di"
    const title1 = "UPT BAHASA"
    const title2 = "UNIVERSITAS MULAWARMAN"
    const slogan = 'Universitas berstandar internasional yang mampu berperan dalam pembangunan bangsa melalui pendidikan, penelitian, dan pengabdian kepada masyarakat yang bertumpu pada sumber daya alam (sda) khususnya hutan tropis lembab (tropical rain forest) dan lingkungannya.'
    const copyright = "2022 UPT Bahasa Universitas Mulawarman. - Didukung oleh"

    return (
        <div>
            {/* <Topography /> */}
            <Hero 
                logo={logo}
                background={background}
                backgroundMobile={backgroundMobile}
                deskripsi={deskripsi}
                title1={title1}
                title2={title2}
                slogan={slogan}
                appName={props.appName}
            >
                { props.children }
            </Hero>
            <br />
            <br />
            <Footer
                copyright={copyright}
            />
        </div>
    );
}


export default pageLayout;